export const requisicoes = {
  list: '/v2/api/professional/historico-requisicoes',
  detail: (requestId) =>
    `/v2/api/professional/historico-requisicoes/${requestId}`,
  retry: (requestId) =>
    `/v2/api/professional/historico-requisicoes/${requestId}/retry`,
  delete: (requestId) =>
    `/v2/api/professional/historico-requisicoes/${requestId}`,
  download: (requestId, attachmentIndex) =>
    `/v2/api/professional/historico-requisicoes/${requestId}/download/${attachmentIndex}`,
  downloadUploaded: (requestId, attachmentIndex) =>
    `/v2/api/professional/historico-requisicoes/${requestId}/download-uploaded/${attachmentIndex}`,
  timeout: (requestId) =>
    `/v2/api/professional/historico-requisicoes/${requestId}`,
}
